import { FC } from 'react';
import { capitalCase } from 'change-case';
import { Tr } from '@utils';
import { getDescriptionTranslationKey, Permission } from '@services';
import { IconButton, Stack, Tooltip } from '@mui/material';
import { FormikCheckbox, FormikCheckboxProps } from '@components/common';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export interface IPermissionCheckboxProps extends FormikCheckboxProps {
	value: Permission;
}

export const PermissionCheckbox: FC<IPermissionCheckboxProps> = ({ formControlLabelProps, value, ...props }) => {
	return (
		<Stack direction="row" alignItems="center" spacing={1} justifyContent="space-between">
			<FormikCheckbox
				value={value}
				{...props}
				formControlLabelProps={{
					label: capitalCase(value.split('_').join(' ')),
					sx: { marginRight: 0 },
					...formControlLabelProps
				}}
			/>
			<Tooltip
				title={<Tr.Portal path={getDescriptionTranslationKey(value)} />}
				arrow
				componentsProps={{ tooltip: { sx: { paddingX: 3, paddingY: 2, maxWidth: 250 } } }}
			>
				<IconButton size="small" sx={{ color: 'common.black' }}>
					<InfoOutlinedIcon color="inherit" fontSize="small" />
				</IconButton>
			</Tooltip>
		</Stack>
	);
};
